// extracted by css-extract-rspack-plugin
export default {"cls1":"AddToListButton-cls1_-Hg","cls2":"AddToListButton-cls2_cBk AddToListButton-cls1_-Hg"};